// @vendors
const get = require('lodash/object/get');
// @constants
const actionTypes = require('constants/contactCenter/actionTypes');
// @utilities
const { APIGet } = require('utilities/APIRequestHelper');

const requestCreditWarranties = creditId => ({
    type: actionTypes.CREDIT_WARRANTIES_REQUEST,
    payload: {
        id: creditId
    }
});

const requestCreditWarrantiesSuccess = (creditId, response) => ({
    type: actionTypes.CREDIT_WARRANTIES_SUCCESS,
    payload: {
        id: creditId,
        data: get(response, 'listaConsultasGarantia.consultaGarantia', [])
    }
});

const requestCreditWarrantiesFailure = (creditId, error) => ({
    type: actionTypes.CREDIT_WARRANTIES_FAILURE,
    payload: {
        id: creditId,
        error
    }
});

const requestWarranties = creditId => (dispatch, getState) => {
    const immCredit = getState().creditsInvestment.getIn(['byId', creditId]);
    const params = {
        query: {
            productoContratoCliente: immCredit.getIn(['oldContract', 'subgroup']),
            numeroContratoCliente: immCredit.getIn(['oldContract', 'contractNumber'])
        }
    };

    dispatch(requestCreditWarranties(creditId));
    return APIGet({dispatch, endpoint: 'creditWarranties', params})
        .then(response => dispatch(requestCreditWarrantiesSuccess(creditId, response)))
        .catch(response => {
            if(!!response.error) {
                dispatch(requestCreditWarrantiesFailure(response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    requestWarranties
}
